import { Grid, Typography } from "@material-ui/core";
import { makeStyles } from "@material-ui/styles";
import { capitalize } from "lodash";
import React, { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import store from "store";
import { ReactComponent as Award } from "../../assets/img/award.svg";
import { ReactComponent as Flag } from "../../assets/img/flag.svg";
import theme from "../../assets/theme";
import AccuracyCard from "./AccuracyCard";
import MarksList from "./MarksList";
import RankCard from "./RankCard";
import BranchAnalysisCard from "./BranchAnalysisCard";
import subjectList from "./subjects.json";
const useStyles = makeStyles((theme) => ({
  container: {
    gap: "20px",
    // padding: "0 20% 0 20%",
    // width: "100vw",
  },
  "@media(max-width: 1024px)": {
    container: {
      // padding: "0 3% 0 3%",
    },
  },
  innerContent: {
    // padding: "2%",
    width: "100%",
    height: "fit-content",
  },
  iconPosition: {
    verticalAlign: "middle",
  },
}));

function getQualificationStatus(marks = {}, qualifyingMarksT = 50) {
  let totalMarks = 0;
  let hasIndividualQualification = false;

  for (const subject in marks) {
    const mark = marks[subject];
    totalMarks += mark;

    if (mark >= qualifyingMarksT) {
      hasIndividualQualification = true;
    }
  }

  // Check if total score qualifies or any individual subject qualifies
  if (totalMarks >= qualifyingMarksT || hasIndividualQualification) {
    return `Qualified`;
  } else {
    return `Not Qualified`;
  }
}

const ComparisonCard = (props) => {
  const { hostname } = window.location;
  const user = store.get("user");
  const instituteId = props.instituteId || store.get("user").institute || "";
  let rankAnalysis = useSelector((state) => state.rankAnalysis);

  const subjectsFrmStore = useSelector((state) => state.allResult.subjects);
  const testTotalMarks = useSelector((state) => state.allResult.testTotalMarks);
  // console.log(amap,"hello");
  const papermarks = {
    BCONM_1: "198",
    "2k25_paper_1": "246",
    "2k25_paper_2": "246",
    "2k24_paper_2": "180",
    "2k24_paper_1": "180",
    "2k23_paper_2": "180",
    "2k23_paper_1": "180",
    "2k22_paper_2": "180",
    "2k22_paper_1": "180",
    "2k21_paper_2": "180",
    "2k21_paper_1": "180",
    "2k20_paper_2": "198",
    "2k20_paper_1": "198",
    "2k19_paper_1": "186",
    "2k19_paper_2": "186",
    "2k18_paper_1": "180",
    "2k18_paper_2": "180",
    "2k17_paper_1": "183",
    "2k17_paper_2": "183",
    "2k16_paper_1": "186",
    "2k16_paper_2": "195",
    "2k15_paper_1": "264",
    "2k15_paper_2": "240",
    "2k14_paper_1": "180",
    "2k14_paper_2": "180",
    "2k13_paper_1": "180",
    "2k13_paper_2": "180",
    "2k12_paper_1": "210",
    "2k12_paper_2": "198",
    "2k11_paper_1": "240",
    "2k11_paper_2": "240",
    EAMCET_MPC: "160",
    NEET: "720",
    NEET_2021: "720",
    "JEE MAINS": "300",
    JEEMAIN_50_BITS: "200",
    BIOP: "300",
    MAINS: "300",
    CUSTOM: "360",
    BITSAT: "390",
  };
  const [rankData, setRankData] = useState({});
  const [branchRankData, setBranchRankData] = useState({});
  const [scoreData, setScoreData] = useState({});
  const [avgScores, setAvgScores] = useState({});
  const [topScores, setTopScores] = useState({});
  const [accData, setAccData] = useState({});
  const [subRanks, setSubRanks] = useState({});
  const [branchSubRanks, setBranchSubRanks] = useState({});
  const [status, setStatus] = useState("");
  const [totalMarks, setTotalMarks] = useState(undefined);
  const [branchRankEnable, setBranchRankEnable] = useState(false);
  const [rankEnable, setRankEnable] = useState(false);
  const [marksEnable, setMarksEnable] = useState(false);
  if (props.customQuestionsCount) {
    papermarks["CUSTOM"] = testTotalMarks; //props.customQuestionsCount * 4;
  }

  useEffect(() => {
    papermarks["CUSTOM"] = props.customQuestionsCount * 4;
    if (Object.keys(rankAnalysis.data) != 0) {
      // console.log(props.data);
      setBranchRankEnable(rankAnalysis.data.showBranchwiseRank);
      setRankEnable(rankAnalysis.data.showRank);
      /* FOR BHASHAYM INSTITUTE IF THE SHOWRANK/SHOWBRANCHWISERANK IS TRUE IT WILL SHOW, FOR OTHER INSTITUTES ' IF WE NOT UPDATE MANUALLY IT WILL SHOW THE RANK AND BRANCH RANK */
      if (instituteId !== "5e7370083d8520a40c4ceaaa" && rankAnalysis.data) {
        const { showBranchwiseRank, showRank } = rankAnalysis.data;
        setBranchRankEnable(showBranchwiseRank !== false);
        setRankEnable(showRank !== false);
      }

      if (rankAnalysis.data.showBranchwiseRank === true && rankAnalysis.data.showRank === true) {
        setBranchRankEnable(false);
        setRankEnable(true);
      }
      setMarksEnable(rankAnalysis.data.showMarks);

      // Initialize safely
      var subRank = {};
      var branchSubRank = {};

      var rankData = {
        rank:
          rankAnalysis &&
          rankAnalysis.data &&
          rankAnalysis.data.ranks &&
          rankAnalysis.data.ranks.total !== undefined
            ? rankAnalysis.data.ranks.total
            : 0,

        totalStudents:
          rankAnalysis &&
          rankAnalysis.data &&
          rankAnalysis.data.totalStudents !== undefined
            ? rankAnalysis.data.totalStudents
            : 0,

        totalStudentsBranchWise:
          rankAnalysis &&
          rankAnalysis.data &&
          rankAnalysis.data.totalStudentsBranchWise !== undefined
            ? rankAnalysis.data.totalStudentsBranchWise
            : "",
      };

      // Safely loop through ranks
      if (
        rankAnalysis &&
        rankAnalysis.data &&
        rankAnalysis.data.ranks &&
        typeof rankAnalysis.data.ranks === "object"
      ) {
        Object.keys(rankAnalysis.data.ranks).forEach(function(key) {
          for (var i = 0; i < subjectsFrmStore.length; i++) {
            var subject = subjectsFrmStore[i];
            if (
              rankAnalysis.data.ranks[key] !== undefined &&
              key
                .toLowerCase()
                .indexOf(subject.replace(/\s+/g, "").toLowerCase()) !== -1
            ) {
              subRank[capitalize(subject)] = rankAnalysis.data.ranks[key];
            }
          }
        });
      }

      setRankData(rankData);

      // Branch rank data with defaults
      var branchRankData = {
        rank:
          rankAnalysis &&
          rankAnalysis.data &&
          rankAnalysis.data.branchRanks &&
          rankAnalysis.data.branchRanks.total !== undefined
            ? rankAnalysis.data.branchRanks.total
            : 0,

        totalStudents:
          rankAnalysis &&
          rankAnalysis.data &&
          rankAnalysis.data.totalStudents !== undefined
            ? rankAnalysis.data.totalStudents
            : 0,
      };

      // Safely loop through branchRanks
      if (
        rankAnalysis &&
        rankAnalysis.data &&
        rankAnalysis.data.branchRanks &&
        typeof rankAnalysis.data.branchRanks === "object"
      ) {
        Object.keys(rankAnalysis.data.branchRanks).forEach(function(key) {
          for (var i = 0; i < subjectsFrmStore.length; i++) {
            var subject = subjectsFrmStore[i];
            if (
              rankAnalysis.data.branchRanks[key] !== undefined &&
              key
                .toLowerCase()
                .indexOf(subject.replace(/\s+/g, "").toLowerCase()) !== -1
            ) {
              branchSubRank[capitalize(subject)] =
                rankAnalysis.data.branchRanks[key];
            }
          }
        });
      }

      setBranchRankData(branchRankData);
      const scoreData = {};
      const avgScoreData = {};
      const topScoreData = {};
      if (
        rankAnalysis &&
        rankAnalysis.data &&
        rankAnalysis.data.showBranchwiseRank === true
      ) {
        subjectsFrmStore.forEach((subject) => {
          if (
            rankAnalysis.data.YourDetails[subjectList[subject].subjectCode] !=
            undefined
          ) {
            scoreData[capitalize(subject)] =
              rankAnalysis.data.YourDetails[subjectList[subject].subjectCode];
            avgScoreData[capitalize(subject)] =
              rankAnalysis.data.AverageBranchWise[
                subjectList[subject].subjectCode
              ] || 0;
            topScoreData[capitalize(subject)] =
              rankAnalysis.data.TopperDetailsBranchWise[
                subjectList[subject].subjectCode
              ] || 0;
          }
        });
      } else {
        subjectsFrmStore.forEach((subject) => {
          if (
            rankAnalysis.data.YourDetails[subjectList[subject].subjectCode] !=
            undefined
          ) {
            scoreData[capitalize(subject)] =
              rankAnalysis.data.YourDetails[subjectList[subject].subjectCode];
            avgScoreData[capitalize(subject)] =
              rankAnalysis.data.Average[subjectList[subject].subjectCode] || 0;
            topScoreData[capitalize(subject)] =
              rankAnalysis.data.TopperDetails[
                subjectList[subject].subjectCode
              ] || 0;
          }
        });
      }
      if (
        window.location.hostname.includes("miity") &&
        (user.level == "X0210780" || user.batch == "X0210780") &&
        props.test_name &&
        props.test_name === "47fa08d0-840b-11ef-b43e-8b0246b9782f"
      ) {
        setStatus(getQualificationStatus(scoreData, 50));
      }
      // T for total
      const accData = {};
      ["YourDetails", "Average", "TopperDetails"].forEach((val) => {
        let correct = 0;
        let total = 0;
        subjectsFrmStore.forEach((subject) => {
          if (
            rankAnalysis.data[val][subjectList[subject].correct] != undefined
          ) {
            correct += rankAnalysis.data[val][subjectList[subject].correct];
            total +=
              rankAnalysis.data[val][subjectList[subject].correct] +
              rankAnalysis.data[val][subjectList[subject].wrong];
          }
        });
        if (total != 0) accData[val] = parseInt((correct / total) * 100);
        else {
          accData[val] = 0;
        }
      });

      setSubRanks(subRank);
      setBranchSubRanks(branchSubRank);
      setAccData(accData);
      setScoreData(scoreData);
      setAvgScores(avgScoreData);
      setTopScores(topScoreData);
      setTotalMarks(rankAnalysis.data.YourDetails.T);
    }
  }, [props, instituteId]);
  const classes = useStyles();

  return (
    <React.Fragment>
      {/* Show message when all analysis flags are false */}
      {rankAnalysis.data.showAnalysis === false &&
      rankAnalysis.data.showRank === false &&
      rankAnalysis.data.showResult === false ? (
        <Grid container className={classes.container} justify="center">
          <Grid item>
            <Typography
              variant="h5"
              align="center"
              style={{
                marginTop: "40px",
                marginBottom: "20px",
                color: theme.palette.success.main,
                fontWeight: "600",
              }}
            >
              Test Submitted Successfully!
            </Typography>
            <Typography
              variant="body1"
              align="center"
              style={{
                color: theme.palette.text.secondary,
                fontSize: "16px",
              }}
            >
              Results will be announced soon
            </Typography>
          </Grid>
        </Grid>
      ) : (
        <Grid container className={classes.container}>
          {/* grade card  */}
          <Grid item className={classes.innerContent}>
            {status && (
              <>
                <br />
                &emsp;
                <Typography
                  variant="body2"
                  color={status === "Qualified" ? "primary" : "error"}
                >
                  Status:&nbsp;<b>{status}</b>
                </Typography>
                <br />
              </>
            )}
            {/* {rankAnalysis.data.showAnalysis === false ? null : (
              <RankCard
                icon={<Award className={classes.iconPosition} />}
                background={"#6a1b9a"}
                cardName="MARKS"
                rank={totalMarks}
                total={
                  papermarks[props.paper] !== undefined
                    ? papermarks[props.paper]
                    : papermarks[props.test_type] != undefined
                    ? papermarks[props.test_type]
                    : "300"
                }
                subjects={Object.keys(scoreData).map((subKey, i) => {
                  return (
                    <MarksList
                      subjectName={subKey}
                      key={i}
                      subjectMarks={scoreData[subKey]}
                      MarksColor={{ color: theme.palette.text.primary }}
                    />
                  );
                })}
              />
            )} */}
          </Grid>

          {/* RANK CARD */}
          {/* <Grid item className={classes.innerContent}>
            {rankAnalysis.data.showRank === false ? null : (
              <React.Fragment>
                {hostname.includes("bhashyam") &&
                user.level == "2119611" ? null : (
                  <RankCard
                    cardName="RANK"
                    icon={<Flag className={classes.iconPosition} />}
                    rank={rankData.rank}
                    total={rankData.totalStudents}
                    background={"#3358B8"}
                    subjects={Object.keys(subRanks).map((subKey, i) => {
                      return (
                        <MarksList
                          key={i}
                          subjectName={subKey}
                          subjectMarks={subRanks[subKey]}
                          MarksColor={{ color: theme.palette.text.primary }}
                        />
                      );
                    })}
                  />
                )}
              </React.Fragment>
            )}
          </Grid> */}

          {/* BRANCH ANALYSIS CARD */}
          <Grid item className={classes.innerContent}>
            {/* {rankAnalysis.data.showRank === true ||
            rankAnalysis.data.showBranchwiseRank === true ? ( */}
            {branchRankEnable === true || rankEnable === true ? (
              <React.Fragment>
                {hostname.includes("bhashyam") &&
                user.level == "2119611" ? null : (
                  <BranchAnalysisCard
                    branchName=""
                    totalStudents={branchRankData.totalStudents || 0}
                    subjectRanks={{
                      ...branchSubRanks,
                      Overall: branchRankData.rank,
                    }}
                    subjectScores={scoreData}
                    avgScores={avgScores}
                    topScores={topScores}
                    branchRankEnabled={branchRankEnable}
                    rankEnabled={rankEnable}
                    marksEnabled={marksEnable}
                    rankData={rankData}
                    overallRankdata={{
                      total: rankData.totalStudents,
                      subRanks: {
                        ...subRanks,
                        rank: rankData.rank,
                      },
                    }}
                    resultData={props.resultData}
                  />
                )}
              </React.Fragment>
            ) : null}
          </Grid>

          {/* ACCURACY CARD */}
          {/* {(hostname.includes("bhashyam") && user.level === "2119611") ||
          (hostname.includes("miity") && user.level === "X0210780") ||
          rankAnalysis.data.showAnalysis === false ? null : (
            <Grid item className={classes.innerContent}>
              <AccuracyCard
                accuracy={accData.YourDetails}
                avg={accData.Average}
                topper={accData.TopperDetails}
              />
            </Grid>
          )} */}
        </Grid>
      )}
    </React.Fragment>
  );
};

export default ComparisonCard;
